import type { ProfileFeatureConfig } from './type';

export const profileFeatureConfig: ProfileFeatureConfig = {
    defaultInstituteId: 1,
    loginManagement: { oidcReady: false, targetClientId: '' },
};
